@import '~style-sheet-helpers/core.less';

.modal-body {
  display: flex;
  flex-direction: column;
  padding: 16px;

  .label {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 500;
    height: 18px;
  }
}
